export default __webpack_public_path__ + "static/media/circle_check_green.65664b9c.svg";